<banner-app [Fixtop]="'fixed-top'" [retroSelected]="false" [infoDueno]="true"  [showPromo]="true"></banner-app>
<div class="root">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">
        <div class="content-wrapper d-flex flex-column align-items-center text-center mt-5 pt-0 pt-md-5 pb-5">
          <div class="row order-2 order-md-1 mt-0 mt-md-5">
            <h2 class="feedback-title mb-3">Haz estado inactivo por un tiempo</h2>
            <p class="feedback-subtitle mb-4">
              <!-- Has estado inactivo por un tiempo. <br class="d-none d-lg-block" /> -->
              Si necesitas ayuda, no dudes en contactarnos.
            </p>
          </div>

          <img
            class="row order-1 order-md-2 feedback-image"
            src="./assets/img/CotizacionPausa.png"
            width="300"
            height="192"
            priority
            alt="Ilustración de una persona sentada en un reloj de arena, representando una pausa."
          />

          <div class="order-3 feedback-actions d-flex align-items-center text-center">
            <button
              type="button"
              class="btn btn-primary btn-lg rounded-pill sura-feedback-btn sura-feedback-btn--white order-2 order-md-1"
              (click)="contactarAsesor()"
            >
              Contactar asesor
            </button>
            <button type="button" class="btn btn-primary btn-lg rounded-pill sura-feedback-btn order-1 order-md-2" (click)="goBack()">
              Seguir en línea
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer-app class="footer-fixed" />
